import { Reducer } from 'redux';
import { SellingPointsState, SellingPointsTypes } from './types';

const INITIAL_STATE: SellingPointsState = {
  sellingPointData: {
    id: '',
    status: 0,
    type: 0,
    allowedAmount: 0,
    name: '',
    document: '',
    registry: '',
    email: '',
    phone: '',
    sellingTerminalId: '',
    transactionPassword: '',
    SellingPointTransactions: [],
    SellingPointPayments: [],
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
  },
  sellingPointsList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<SellingPointsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST SELLING POINTS
    case SellingPointsTypes.LIST_SELLING_POINTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingPointsList: INITIAL_STATE.sellingPointsList,
      };
    case SellingPointsTypes.LIST_SELLING_POINTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        sellingPointsList: action.payload.sellingPointsList,
      };
    case SellingPointsTypes.LIST_SELLING_POINTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingPointsList: INITIAL_STATE.sellingPointsList,
      };
    // CASES GET SELLING POINT
    case SellingPointsTypes.GET_SELLING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingPointData: INITIAL_STATE.sellingPointData,
      };
    case SellingPointsTypes.GET_SELLING_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingPointData: action.payload.sellingPointData,
      };
    case SellingPointsTypes.GET_SELLING_POINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingPointData: INITIAL_STATE.sellingPointData,
      };
    // CASES FILTER SELLING POINTS
    case SellingPointsTypes.FILTER_SELLING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingPointsList: INITIAL_STATE.sellingPointsList,
      };
    case SellingPointsTypes.FILTER_SELLING_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        sellingPointsList: action.payload.sellingPointsList,
      };
    case SellingPointsTypes.FILTER_SELLING_POINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingPointsList: INITIAL_STATE.sellingPointsList,
      };
    // CASES CREATE SELLING POINT
    case SellingPointsTypes.CREATE_SELLING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingPointData: INITIAL_STATE.sellingPointData,
      };
    case SellingPointsTypes.CREATE_SELLING_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingPointData: action.payload.sellingPointData,
      };
    case SellingPointsTypes.CREATE_SELLING_POINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingPointData: INITIAL_STATE.sellingPointData,
      };
    // CASES UPDATE SELLING POINT
    case SellingPointsTypes.UPDATE_SELLING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingPointsTypes.UPDATE_SELLING_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingPointData: action.payload.sellingPointData,
      };
    case SellingPointsTypes.UPDATE_SELLING_POINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES DELETE SELLING POINT
    case SellingPointsTypes.DELETE_SELLING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingPointsTypes.DELETE_SELLING_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingPointsTypes.DELETE_SELLING_POINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES ADD PAYMENT SELLING POINT
    case SellingPointsTypes.ADD_PAYMENT_SELLING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingPointsTypes.ADD_PAYMENT_SELLING_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingPointsTypes.ADD_PAYMENT_SELLING_POINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES CHANGE SELLING POINT STATUS
    case SellingPointsTypes.CHANGE_SELLING_POINT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingPointsTypes.CHANGE_SELLING_POINT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingPointsTypes.CHANGE_SELLING_POINT_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES CHANGE PASSWORD
    case SellingPointsTypes.CHANGE_SELLINPOINT_PASSWORD_REQUEST:
      return { ...state, loading: true, error: false };
    case SellingPointsTypes.CHANGE_SELLINPOINT_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: false };
    case SellingPointsTypes.CHANGE_SELLINPOINT_PASSWORD_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default reducer;
